import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './SortedTableViewColumns.styled';
import { getSortedViewColumns } from './SortedTableViewColumns.utils';

export const SortedTableViewColumns = ({ columns, options, components = {}, onColumnUpdate }) => {
  const classes = useStyles();
  const textLabels = options.textLabels.viewColumns;
  const CheckboxComponent = components.Checkbox || Checkbox;
  const sortedColumns = getSortedViewColumns(columns);

  return (
    <FormControl component="fieldset" className={classes.root} aria-label={textLabels.titleAria}>
      <Typography variant="caption" className={classes.title}>
        {textLabels.title}
      </Typography>
      <FormGroup className={classes.formGroup}>
        {sortedColumns.map(({ column, index }) => (
          <FormControlLabel
            key={index}
            classes={{
              root: classes.formControl,
              label: classes.label
            }}
            control={
              <CheckboxComponent
                color="primary"
                data-description="table-view-col"
                className={classes.checkbox}
                classes={{
                  root: classes.checkboxRoot,
                  checked: classes.checked
                }}
                onChange={() => onColumnUpdate(index)}
                checked={column.display === 'true' || column.display === true}
                value={column.name}
              />
            }
            label={column.label}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};
